
import { environment } from "../environments/environment";
export const apiCredentials = {
    "UserName": "user@admin",
    "Password": "$yngent@2022"
  };
  export const snapapiCredentials = {
  "UserName": "SNAP@admin",
  "Password": "$yngent@2022"
  };

export const ClowderConfig = environment.ClowderConfig;
export const ClowderfrontUrl = environment.cloudfrontUrl;
export const ApiUrl = environment['ApiUrl']; 
export const SnapApiUrl = environment['snapApiUrl']; 
export class AppSettings {
  public static postLoginToken = ApiUrl + 'Login';
  public static storenregister = ApiUrl + 'api/users/storenregister';
  public static changeprofilepassword = ApiUrl + 'api/users/credentials/changeprofilepassword';
  public static validatemail = ApiUrl + 'api/users/validatemail';
  public static validatephone = ApiUrl + 'api/users/validatephone';
  public static forgotPassword = ApiUrl + 'api/users/forgotpassword';
  public static changePassword = ApiUrl + 'api/users/changepassword';
  public static snapLogin = SnapApiUrl + 'api/Authentication/Login';
  public static fetchUser = SnapApiUrl + 'api/findusers?';
  public static updateGrowersLastLogin = SnapApiUrl + 'api/users/UpdateGrowersLastLogin';//When user successfully login
  public static updateGrowersLoginAttempt = SnapApiUrl + 'api/users/UpdateGrowersLoginAttempt';//failed login attempt
  public static activeUser = ApiUrl + 'api/users/ActivateUser?';
  public static storenvalidatetoken = ApiUrl + 'api/users/validatetoken';
  public static emailUsers = ApiUrl + 'api/users?';
  public static programSchedule = SnapApiUrl + 'api/programschedule';
  public static getgrowerdetailsbyEmailId = SnapApiUrl + 'api/getgrowerdetailsbyEmailId?emailId=';
  public static insertprogramdetails = SnapApiUrl + 'api/insertprogramdetails';
  public static getProgramStatus = SnapApiUrl + 'api/programstatus?growerId=';
  public static getStatesDropDown = SnapApiUrl+ 'api/states';
 // public static updateTrialDate = SnapApiUrl+ 'api/updatetrialmodifieddate?trialId=';
  public static trialRegistration = SnapApiUrl+'api/trialregistration';
  public static dataErrLog = SnapApiUrl+'api/users/logerror';
}

export class StoranConstant {
    public static getEnvironmentVariable() {
        let environment1: string;
        let data = {};
        environment1 = window.location.hostname;
        switch (environment1) {
            case 'localhost':
                data = {
                        clientId: '0oa281icw0zQ0HZoE0h8',
                        issuer: 'https://signin-test.syngenta.com/oauth2/ausqmgapztkTfvQg70h7',
                        redirectUri: 'http://localhost:4200/program',
                        scopes: ['openid', 'profile', 'email'],
                        tokenManager: {
                        autoRenew: true,
                        expireEarlySeconds: 30,
                        storage: 'localStorage'
                      }
                    }
                break;

            case 'stagesupport.storensatisfaction.com':
                  data = {
                      clientId: '0oa281icw0zQ0HZoE0h8',
                      issuer: 'https://signin-test.syngenta.com/oauth2/ausqmgapztkTfvQg70h7',
                      redirectUri: 'https://stagesupport.storensatisfaction.com/program',
                      scopes: ['openid', 'profile', 'email'],
                      tokenManager: {
                        autoRenew: true,
                        expireEarlySeconds: 30,
                        storage: 'localStorage'
                      }
                  };
                  
                  break;
            case 'stageproject.storensatisfaction.com':
                  data = {

                      clientId: '0oa281icw0zQ0HZoE0h8',
                      issuer: 'https://signin-test.syngenta.com/oauth2/ausqmgapztkTfvQg70h7',
                      redirectUri: 'https://stageproject.storensatisfaction.com/program',
                      scopes: ['openid', 'profile', 'email'],
                      tokenManager: {
                        autoRenew: true,
                        expireEarlySeconds: 30,
                        storage: 'localStorage'
                      }
                  };
                  break;
            case 'storensatisfaction.com':
                data = {
                    clientId: '0oan4rr88nobFyHru4x7',
                    issuer: 'https://signin.syngenta.com/oauth2/aus575jkuuZAOVhr74x6',
                    redirectUri: 'https://www.storensatisfaction.com/program',
                    scopes: ['openid', 'profile', 'email'],
                    tokenManager: {
                        autoRenew: true,
                        expireEarlySeconds: 30,
                        storage: 'localStorage'
                      }
                };
                break;
                case 'www.storensatisfaction.com':
                    data = {
                        clientId: '0oan4rr88nobFyHru4x7',
                        issuer: 'https://signin.syngenta.com/oauth2/aus575jkuuZAOVhr74x6',
                        redirectUri: 'https://www.storensatisfaction.com/program',
                        scopes: ['openid', 'profile', 'email'],
                        tokenManager: {
                            autoRenew: true,
                            expireEarlySeconds: 30,
                            storage: 'localStorage'
                          }
                    };
                    break;
            default:
                data = {
                    clientId: '0oa281icw0zQ0HZoE0h8',
                    issuer: 'https://signin-test.syngenta.com/oauth2/ausqmgapztkTfvQg70h7',
                    redirectUri: 'https://stagesupport.storensatisfaction.com/program',
                    scopes: ['openid', 'profile', 'email'],
                    tokenManager: {
                        autoRenew: true,
                        expireEarlySeconds: 30,
                        storage: 'localStorage'
                      }
                }
                break;
      }
       
        return data;
    }


}



